import { DealStatusEnum, LookbackOption, type PersistedDefaultTabProps } from '@talos/kyoko';
import type { RepoTabProps } from './Repos';

export const OPEN_REPOS_TAB_ID = 'open-repos';
export const ACTIVE_REPOS_TAB_ID = 'active-repos';

export const DEFAULT_REPO_TABS: PersistedDefaultTabProps<RepoTabProps>[] = [
  {
    label: 'Open',
    id: OPEN_REPOS_TAB_ID,
    closable: false,
    editable: false,
    defaultFilter: {
      Statuses: [DealStatusEnum.New, DealStatusEnum.Pending, DealStatusEnum.Live],
    },
  },
  {
    label: 'Active',
    id: ACTIVE_REPOS_TAB_ID,
    closable: false,
    editable: false,
    defaultFilter: {
      Statuses: [DealStatusEnum.Live],
    },
  },
];

export const NEW_REPO_TAB_DEFAULTS: RepoTabProps = {
  defaultFilter: {
    _start: LookbackOption.PastWeek,
    TimestampField: 'TradeTime',
  },
};
